import React, { Component } from 'react';
import { PaginationHelper } from './helpers/PaginationHelper';
import { Pagination, Grid, Row, Col, Form, ControlLabel } from 'react-bootstrap';
import Select from "react-select";

export class PaginationBuilder extends Component {

    onChangePage(pageNumber, disabled) {
        if (!disabled) {
            this.props.onChangePage(pageNumber);
        }
    }

    onChangeElementsPerPage(e) {
        const elementsPerPage = e;
        if(null === elementsPerPage || undefined === elementsPerPage || "" === elementsPerPage) {
            // It should have always a non null or undefined value
            return;
        }

        const totalPages = PaginationHelper.getTotalPages(this.props.dataLength, elementsPerPage);

        if (0 !== totalPages) {
            this.props.onChangePage(this.props.currentPage > totalPages ? totalPages : this.props.currentPage);
        }
        else {
            this.props.onChangePage(1);
        }

        this.props.onChangeElementsPerPage(elementsPerPage);
    }

    render() {
        const { currentPage, elementsPerPage, dataLength } = this.props;

        const totalPages = PaginationHelper.getTotalPages(dataLength, elementsPerPage);
        const activePage = currentPage > totalPages ? totalPages : currentPage;

        let firstPage = activePage - 2;
        let lastPage = activePage + 2;
        if (1 > firstPage && totalPages < lastPage) {
            firstPage = 1;
            lastPage = totalPages;
        }
        else if (1 > firstPage) {
            lastPage += firstPage * -1 + 1;
            lastPage = lastPage > totalPages ? totalPages : lastPage;
            firstPage = 1;
        }
        else if (totalPages < lastPage) {
            firstPage -= lastPage - totalPages;
            firstPage = 1 > firstPage ? 1 : firstPage;
            lastPage = totalPages;
        }

        let pageItems = [];
        for (let i = firstPage; i <= lastPage; i++) {
            pageItems.push(
                <Pagination.Item key={i} active={i === activePage} onClick={() => this.props.onChangePage(i)}>{i}</Pagination.Item>
            );
        }

        return (
            <Grid className="pagination-grid" fluid>
                <Row>
                    <Col sm={7}>
                        <Pagination className="margin-top-0">
                            <Pagination.First disabled={1 === activePage} onClick={() => this.onChangePage(1, 1 === activePage)} />
                            <Pagination.Prev disabled={1 === activePage} onClick={() => this.onChangePage(activePage - 1, 1 === activePage)} />

                            {pageItems}

                            <Pagination.Next disabled={totalPages === activePage} onClick={() => this.onChangePage(activePage + 1, totalPages === activePage)} />
                            <Pagination.Last disabled={totalPages === activePage} onClick={() => this.onChangePage(totalPages, totalPages === activePage)} />
                        </Pagination>
                    </Col>
                    <Col sm={5}>
                        <Form horizontal>
                            <Col className="pagination-elements-col" componentClass={ControlLabel} xs={3} sm={6}>Nº Elementos</Col>
                            <Col className="pagination-elements-col" xs={3} sm={6}>
                                <Select
                                    className="custom-multiselect custom-multiselect-small"
                                    placeholder="Paginação"
                                    noOptionsMessage={() => "Não Configurado"}
                                    onChange={(e) => this.onChangeElementsPerPage(e)}
                                    options={[5, 10, 25, 50, 100]}
                                    isMulti={false}
                                    isClearable={false}
                                    menuPlacement="auto"
                                    getOptionValue={value => value}
                                    getOptionLabel={label => label}
                                    value={[elementsPerPage]}
                                />
                            </Col>
                        </Form>
                    </Col>
                </Row>
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/PaginationBuilder.js